import React, { useEffect, useState } from "react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import {
  Table,
  Loader,
  Button,
  Grid,
  Dropdown
} from "semantic-ui-react";
import { Container, Content, Center, ButtonGreen, Text, Wrapper } from './styled'
import { producaov2 } from "../../../../services/apis";
import swal from "sweetalert";

function RelatoriosTickets() {
  const [loading, setLoaning] = useState(false);
  const [loadingReport, setLoadingReport] = useState(false);
  const [dateStart, setDateStart] = useState('');
  const [dateEnd, setDateEnd] = useState('');
  const [tickets, setTickets] = useState(null);
  const [tutor, setTutor] = useState('0');
  const [avg, setAvg] = useState('');

  const tutorOptions = [
    { key: 0, value: "0", text: "Todos" },
    { key: 1, value: "48", text: "Thiago Coutinho" },
    { key: 2, value: "18805", text: "Rafael Oliveira" },
    { key: 3, value: "36119", text: "Daniel Voitto" },
    { key: 4, value: "7515", text: "Daniel Fraga" },
    { key: 5, value: "240453", text: "Axell Montinotti" },
    { key: 6, value: "255296", text: "Alicia Souza" },
  ];

  const getTutor = (id) => {
    const tutorName = tutorOptions.find(t => +t.value === id)
    if (!tutorName) {
      return 'tutor não encontrado'
    }

    return tutorName.text
  }

  useEffect(() => {
    if (!dateStart || !dateEnd) return;
    getTickets();
  }, [tutor])

  const getTutoresId = () => {
    if (tutor === '0') {
      return tutorOptions.map(t => +t.value).filter(t => !!t);
    }

    return tutor
  }

  const getTickets = async () => {
    setLoaning(true);

    if (!dateStart || !dateEnd) {
      swal("As datas são obrigatórias",
        "Selecione uma data inicial e final",
        "error"
      )
      return
    }
    const idsTutor = getTutoresId()
    const ids = Array.isArray(idsTutor) ? idsTutor.join(',') : idsTutor
    await producaov2.get('/admin/ticket/analyze', {
      params: { dateStart, dateEnd, idTutor: ids }
    }).then(res => {
      setTickets(res.data.tickets)
      setAvg(res.data.avg)
    }).catch(err => {
      console.error(err)
      swal(
        "Problema ao obter os tickets!",
        "Tente novamente se persistir, nos contate",
        "error"
      );
    })
    setLoaning(false)
  }

  const handleGenerateReport = async () => {
    setLoadingReport(true)

    const url = await producaov2.post('/admin/reports/tickets', {
      dateStart,
      dateEnd,
      idTutor: getTutoresId()
    })
      .then(res => {
        return res.data.url
      }).catch((err) => {
        console.error(err)
        return null
      })

    if (!url) {
      swal(
        "Problema ao gerar o relatório",
        "Tente novamente se persistir, nos contate",
        "error"
      );

      return;
    }

    window.open(url, "_blank")

    setLoadingReport(false)
  }

  const formatDate = (value) => {
    const date = new Date(value)
    date.setHours(date.getHours() + 3)
    return date.toLocaleString().replace(', ', ' - ')
  }

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <Content>
          <Center>
            <div className="ui fluid" style={{ width: "20%", marginRight: '10px' }}>
              <Dropdown
                placeholder="Consultor:"
                selection
                options={tutorOptions}
                onChange={(e, { value }) => setTutor(value)}
                value={tutor} />
            </div>
            <div className="ui fluid" style={{ width: "50%" }}>
              <strong>De:</strong>
              <div className="ui input fluid">
                <input
                  type="date"
                  onChange={(e) => setDateStart(e.target.value)}
                  value={dateStart}
                />
              </div>
            </div>
            <div className="ui fluid"
              style={{ marginLeft: "16px", width: "50%" }}
            >
              <strong>Até:</strong>
              <div className="ui input fluid">
                <input
                  type="date"
                  onChange={(e) => setDateEnd(e.target.value)}
                  value={dateEnd}
                />
              </div>
            </div>
            <ButtonGreen onClick={() => getTickets()}>Buscar</ButtonGreen>
          </Center>

          <Wrapper>
            {avg && (
              <div>
                Media de tempo de resposta:
                <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
                  {avg}
                </span>
              </div>
            )}
            {
              tickets && <Button
                color="orange"
                onClick={handleGenerateReport}
                loading={loadingReport}
                style={{ marginTop: "10px" }}
              >
                Gerar Relatório
              </Button>
            }
          </Wrapper>

          <Table stackable>
            <Table.Header>
              <Table.HeaderCell style={{ width: "20%" }}>
                <Center>ID</Center>
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>Data de pergunta</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Data da resposta</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Tutor</Center >
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Tempo de resposta</Center >
              </Table.HeaderCell>
            </Table.Header>

            {loading ? <Loader active={loading} /> :
              tickets ? tickets.map(ticket => {
                return (
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>
                        <Center>
                          <a href={`https://www.voitto.com.br/online/tickets/${ticket.idTicket}`}
                            target="_blank" rel="noopener noreferrer">
                            {ticket.idTicket}
                          </a>
                        </Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{formatDate(ticket.date)}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{ticket?.response ? formatDate(ticket.response.date) : 'Sem resposta'}</Center>
                      </Table.Cell>
                      <Table.Cell >
                        <Center>{ticket?.response ? getTutor(ticket.response.userId) : ''}</Center>
                      </Table.Cell>
                      <Table.Cell >
                        <Center>{ticket?.timeResponse || ''}</Center>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>)
              }) : <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan='7'>
                    <Text>Nenhum ticket encontrado</Text>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>}
          </Table>
        </Content>
      </Container>
    </div>
  )
}

export default RelatoriosTickets;
